import React, { Component } from 'react';
import autoBind from 'react-autobind/src/autoBind';
import TableHelper from 'src/utils/table-helper';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import { connect } from 'react-redux';
import {
    asyncRequest,
    Entities,
    fetchById,
    getEntities,
    getUpdatedEntity,
    patch,
    save,
    search,
    TOMCAT_URL,
} from 'src/common';
import { setSliderIndex } from 'src/actions/form';

class FindMyBusRequestsOpenAiTable extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper({
            onRowClick: this.onRowClick,
            pageSize: 100,
        });
    }

    render() {
        const { companies, t, taskInfo } = this.props;
        const tableData = [];
        for (const company of companies) {
            tableData.push({
                address: company.address,
                email: company.email,
                website: company.website,
                numberOfBuses: company.numberOfBuses,
                distanceToDeparture: company.distanceToDeparture,
            });
        }
        return (
            <div className="react-bs-table-find-my-bus margin-top-10 margin-bottom-10">
                <h2 style={{ margin: 0 }}>{t('find_my_bus.open_ai_results')}</h2>
                <div style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'row', marginBottom: 5 }}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 5 }}>
                        War diese Antwort hilfreich?
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <button
                                className={`glyphicon glyphicon-thumbs-up transparent no-border ${taskInfo.openAIPositiveAnswer ? 'text-success' : ''}`}
                                onClick={e => {
                                    this.rateAnswer(e, true);
                                }}
                            />
                            <button
                                className={`glyphicon glyphicon-thumbs-down transparent no-border ${!taskInfo.openAIPositiveAnswer ? 'text-danger' : ''}`}
                                onClick={e => {
                                    this.rateAnswer(e, false);
                                }}
                            />
                        </div>
                    </div>
                </div>

                <BootstrapTableErrorBoundary>
                    <BootstrapTable
                        tableContainerClass="react-bs-table-find-my-bus"
                        style={{ height: '200px' }}
                        data={tableData}
                        striped={true}
                        hover={true}
                        exportCSV={false}
                        condensed={true}
                        pagination={false}
                        options={{ tableStyle: { height: '200px', overflowY: 'auto' } }}
                        // options={Object.assign(
                        //     // { toolBar: this.createCustomToolBar },
                        //     // this.tableHelper.getOptions(finishFetching),
                        // )}
                        selectRow={Object.assign({}, this.tableHelper.getRowProps())}>
                        <TableHeaderColumn
                            columnTitle={true}
                            width="80"
                            dataField="website"
                            dataFormat={linkFormatter}
                            isKey={true}
                            export={true}>
                            {t('find_my_bus.homepage')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} width="80" dataField="email" dataSort={true}>
                            {t('search_requests.email')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} width="80" dataField="address" dataSort={true}>
                            {t('contact_data.address')}
                        </TableHeaderColumn>
                        {/*<TableHeaderColumn columnTitle={true} width="20" dataField="numberOfBuses" dataSort={true}>*/}
                        {/*    Verfügbare Busse*/}
                        {/*</TableHeaderColumn>*/}
                        <TableHeaderColumn
                            columnTitle={true}
                            width="20"
                            dataField="distanceToDeparture"
                            dataSort={true}>
                            {t('find_my_bus.distance_in_km')}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="actions"
                            width="60"
                            dataFormat={this.tableActionsFormatter}
                            export={false}>
                            {t('common_phrases.actions')}
                        </TableHeaderColumn>
                    </BootstrapTable>
                </BootstrapTableErrorBoundary>
            </div>
        );
    }

    getEmail(request) {
        asyncRequest({
            endpoint: `${TOMCAT_URL}api/${Entities.FIND_MY_BUS_REQUEST.repository}/get-request-email?findMyBusId=${this.props.taskInfo.id}`,
        })
            .then(response => {
                const mailtoLink = `mailto:${request.email}?subject=${encodeURIComponent('Anfrage Bus')}&body=${encodeURIComponent(response.json.text)}`;
                window.open(mailtoLink);
            })
            .catch(error => {
                console.log('Error', error);
            });
    }

    rateAnswer(e, positive) {
        const { taskInfo } = this.props;
        e.target.classList.add(positive ? 'text-success' : 'text-danger');
        asyncRequest({
            method: 'PATCH',
            endpoint: `${TOMCAT_URL}api/${Entities.FIND_MY_BUS_REQUEST.repository}/rate-answer?findMyBusId=${this.props.taskInfo.id}&positive=${positive}`,
        })
            .then(response => {})
            .catch(error => {
                console.log('Error', error);
            });
    }

    tableActionsFormatter(cell, request) {
        const { t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title="Anfrage an Operator schicken"
                    onClick={() => {
                        this.getEmail(request);
                    }}>
                    <span className="glyphicon glyphicon-envelope text-info" />
                </button>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { isTripCompany } = ownProps;
    const entity = isTripCompany ? Entities.TRIP_COMPANY : Entities.BUS_COMPANY;

    return {
        company: getUpdatedEntity(state, entity),
        tripCategories: getEntities(state, Entities.TRIP_CATEGORY),
        tripAttributes: getEntities(state, Entities.TRIP_ATTRIBUTE),
        selectedSliderIndex: state.selectedSliderIndex,
    };
};
export const linkFormatter = cell => {
    if (cell) {
        let url = cell;
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = `https://${url}`;
        }
        return `<a href="${url}" target="_blank">${cell}</a>`;
    }
};

export default connect(
    mapStateToProps,
    {
        fetchById,
        search,
        patch,
        save,
        setSliderIndex,
    },
    null,
    { withRef: true },
)(FindMyBusRequestsOpenAiTable);
